module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-article"
  }, [_c('div', {
    staticClass: "new-article-header",
    style: ({
      background: _vm.skinColor
    })
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.hiddenNewArticle
    }
  }), _vm._v("新建话题\n     ")]), _vm._v(" "), _c('div', {
    staticClass: "new-article-content"
  }, [_c('div', {
    staticClass: "new-article-type"
  }, [_c('span', [_vm._v("请选择主题类别:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newArticleType),
      expression: "newArticleType",
      modifiers: {
        "trim": true
      }
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newArticleType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.types), function(opt, index) {
    return _c('option', {
      key: index
    }, [_vm._v(_vm._s(opt))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "new-article-title text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newArticleTitle),
      expression: "newArticleTitle",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "title-input",
    attrs: {
      "type": "text",
      "pattern": ".{10,}",
      "placeholder": "请输入标题，不少于十个字符(去除前后空格)"
    },
    domProps: {
      "value": (_vm.newArticleTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newArticleTitle = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "textBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "new-article-body"
  }, [_c('Reply', {
    attrs: {
      "placeholderOpt": "请发表主题 (づ｡◕ᴗᴗ◕｡)づ",
      "isShowclose": "false",
      "btnText": '发布',
      "event": "newArticle"
    },
    on: {
      "newArticle": _vm.sendNewArticle
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-b3e29c80"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/NewArticle/NewArticle.vue
// module id = 335
// module chunks = 4